import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'monthString',
  standalone: true,
})
export class MonthStringPipe implements PipeTransform {
  private monthStrings = [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
  ];
  transform(month: number | undefined): string {
    if (month) {
      return this.monthStrings[month - 1];
    } else {
      return '';
    }
  }
}
